export default __webpack_public_path__ + "static/countryoforigin-bb1cb7df08b0cc8d4f06357a113e6f6e.svg";